require('../../modules/es.typed-array.uint8-clamped-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Uint8ClampedArray;
